// removed by extract-text-webpack-plugin
module.exports = {"file":"_3vfv9","button":"_13a4x","icon":"J6muc"};


//////////////////
// WEBPACK FOOTER
// ./app/components/upload-image-button/upload-image-button.scss
// module id = 1766
// module chunks = 0